/**
 * RelatedItems component.
 * @module components/theme/RelatedItems/RelatedItems
 */

import { useIntl } from 'react-intl';
import { defineMessages, injectIntl } from 'react-intl';
import PropTypes from 'prop-types';
import { Container } from 'semantic-ui-react';
import DefaultTemplate from '../BlockTemplates/Listing/Default/DefaultTemplate';

const messages = defineMessages({
  relatedContent: {
    id: 'Related Content',
    defaultMessage: 'Related Content',
  },
  readMore: {
    id: 'Read more',
    defaultMessage: 'Read more',
  },
});

/**
 * Related Items component.
 * @function RelatedItems
 * @param {array} tags Array of related items.
 * @returns {string} Markup of the component.
 */

const RelatedItems = ({ content }) => {
  const intl = useIntl();

  if (!content?.relatedItems?.length) {
    return null;
  }

  return (
    <Container className="related-content">
      <h2 className="section-subtitle">
        <span>{intl.formatMessage(messages.readMore)}</span>
      </h2>
      <DefaultTemplate items={content.relatedItems} showThumbnail />
    </Container>
  );
};

/**
 * Property types.
 * @property {Object} propTypes Property types.
 * @static
 */
RelatedItems.propTypes = {
  content: PropTypes.shape({
    relatedItems: PropTypes.arrayOf(
      PropTypes.shape({
        '@id': PropTypes.string.isRequired,
        title: PropTypes.string.isRequired,
      }),
    ),
  }),
};

export default injectIntl(RelatedItems);
